<template>
    <div class="header-results">
        <Title :title="getTranslatedText('latest results')">
            <DateInput dateType="date" @getDate="handleDateChange" />
        </Title>
        <TabGame @game-default="handleInitGame" @select-game="onSelectGame" />
    </div>
    <Loading v-if="isLoading" />
    <template v-else>
        <div class="lastest-results">
            <div v-if="resultsData.length > 0" class="lastest-results__content">
                <div class="lastest-results__item" v-for="(item, index) in resultsData" :key="index">
                    <div class="lastest-results__item--draw-date-group">
                        <span>{{ item.date_label }}</span>
                    </div>
                    <div class="lastest-results__item--content">
                        <div class="lastest-results__item--draw-infor" v-for="(draw, idx) in item.draws" :key="idx">
                            <p class="draw-date">{{ getTranslatedText(draw.draw_name) }}: {{ renderHour(draw.draw_date) }}</p>
                            <div class="numbers">
                                <Number v-for="(n, i) in renderNumbers(draw.results).numbers" :key="i" :number="n.value"
                                    :bgColor="n.color_code" />
                                <div class="bonus-number" v-if="renderNumbers(draw.results).bonusNumer.length > 0">
                                    <Number v-for="(n, i) in renderNumbers(draw.results).bonusNumer" :key="i"
                                        :number="n.value" :bgColor="n.color_code" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmptyComponent v-else :description="getTranslatedText('empty lastest result')" />
        </div>
    </template>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";
import utilsMixins from "@/mixins/function-utils";
import Title from "@/components/common/title";
import Number from "@/components/common/number";
import EmptyComponent from '@/components/common/empty';
import Loading from "@/components/common/loading/loading.vue";
import HomeService from "@/services/home/index.service.ts";
import TabGame from "@/components/common/tab/tab-game.vue"
import DateInput from "@/components/common/filter/date.vue";

import EventBus from '@/utils/EventBus';
import { notifyApiError } from "@/utils/notify";

export default {
    mixins: [languageMixins, utilsMixins],
    components: { Title, Number, EmptyComponent, Loading, TabGame, DateInput },
    data() {
        return {
            isLoading: false,
            resultsData: [],
            marketGroup: [],
            intervalTimer: [],
            timeout: null,
            gameSelected: {},
            dateFilter: null,
        }
    },
    created() {
        EventBus.on('date-change', (date) => this.handleFilterByDate(date))
        EventBus.on('reload-history', (gameSlug) => this.handleReloadHistory(gameSlug))
    },
    unmounted() {
        EventBus.off('date-change', (date) => this.handleFilterByDate(date))
        EventBus.off('reload-history', (gameSlug) => this.handleReloadHistory(gameSlug))
    },
    methods: {
        handleInitData(date = null) {
            setTimeout(async () => {
                const slug = this.gameSelected?.slug;
                if (!slug) {
                    return;
                }
                const gameData = (this.$store.state.gameMarket || []).find(
                    (x) => x.slug == slug
                );
                this.marketGroup = gameData?.groups || [];

                try {
                    this.isLoading = true;
                    const res = await HomeService.getLastestResultsByGame(12, slug, date);
                    if (res.status == 'success') {
                        this.resultsData = res.result;
                    }
                } catch (error) {
                    this.resultsData = [];
                    notifyApiError(error);

                } finally {
                    this.isLoading = false;
                }
            });
        },

        renderNumbers(result) {
            const gameSlug = this.gameSelected?.slug;
            const gameNumbers = this.$store.state.gameMarket || [];
            const numbers = gameNumbers.find((x) => x.slug == gameSlug)?.balls;
            const results = result?.[0] || [];
            const bonus = result?.[1];
            if (!numbers) {
                return { numbers: [], bonusNumer: [] };
            }
            return {
                numbers: this.filterAndSortNumbers(numbers, results),
                bonusNumer:
                    bonus?.length > 0
                        ? numbers.filter((item) => bonus.includes(item.value))
                        : [],
            };
        },

        handleFilterByDate(date) {
            this.dateFilter = date;
            this.handleInitData(date)
        },

        handleReloadHistory(gameSlug) {
            if (gameSlug == this.gameSelected.slug) {
                this.handleInitData();
            }
        },

        handleInitGame(game) {
            if (!game) return;
            this.gameSelected = game;
            this.handleInitData(this.dateFilter);
        },

        onSelectGame(game) {
            this.gameSelected = game;
            this.handleInitData(this.dateFilter);
        },

        handleDateChange(date) {
            EventBus.emit('date-change', date)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/public/scss/components/lastest-results/index.scss";
</style>